
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 46 46"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{staticClass:"hover",attrs:{"data-name":"Ellipse731","cx":"23","cy":"23","r":"23","fill":"#4885ed","opacity":".01"}}),_c('g',{staticClass:"selectedInner",attrs:{"data-name":"Ellipse728","transform":"translate(11 11)","fill":"none","stroke":"#4885ed","stroke-width":"2"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"12","stroke":"none"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"11"}})]),_c('circle',{staticClass:"selectedRing",attrs:{"data-name":"Ellipse734","cx":"6.5","cy":"6.5","r":"6.5","transform":"translate(16.5 16.5)","fill":"#4885ed"}})])
          )
        }
      }
    